import React, { useMemo, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TableSortLabel,
  Menu,
  Alert,
  AlertTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { TypographyText } from "../../customComponent/Typography"
import { SlOptionsVertical } from "react-icons/sl";
import { Box, Checkbox, MenuItem } from "@mui/material";
import { TbEdit } from "react-icons/tb";
import { AiOutlineEye } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";

import "./IncentiveTable.css";

import { MdNotInterested } from "react-icons/md";

import { BiSortAlt2 } from "react-icons/bi";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import { partnerCommissionCategoryEdit, partnerCommissionDeleteAction, partnerCommissionFindAction } from "../../../actions/IncentiveCategoryActions";
import PremissionDialog from "../../customComponent/premissionDialog";
import TableNoItemComponent from "../../customComponent/TableNoItemComponent";
import { SubmitButton } from "../../customComponent/Buttons";
import InputField from "../../customComponent/InputField";
import { useEffect } from "react";

export const IncentiveTable = ({
  columns,
  data,
  allRoleFindSuccess,
  component,
  showUrl,
  subMenu,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedRows, setSelectedRows] = useState([]);
  // custom Hooks
  const { isDeletePrevilage, isEditPrevilage } = usePrivilegeCheck();
  const { privilege, hasPrivilege, isCreatePrevilage } = usePrivilegeCheck();
  const [openAlert, setOpenAlert] = useState(false);

  // HandleClose dialog

  const handleCloseDialog = () => {
    setOpenAlert(false);
  };

  const [actionButtonShow, setActionButtonShow] = useState(null);
  const [tableId, setTableId] = useState("");
  const [roleData, setRoleData] = useState(allRoleFindSuccess);
  const [popupData, setPopupData] = useState({});
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false)
  const [editData, setEditData] = useState([])
  const [commissionPercentage, setCommissionPercentage] = useState('')
  const [roleName, setRoleName] = useState('')  

  const openActionButton = Boolean(actionButtonShow);

  const { partnerCommissionEditSuccess } = useSelector((state) => state.partnerCommissionEdit)

  useEffect(() => {
     dispatch(partnerCommissionFindAction());
     handleClose()
  }, [partnerCommissionEditSuccess])

  const handleClickAction = (event, id) => {
    setActionButtonShow(event.currentTarget);
    setTableId(id);
  };

  const handleCloseAction = () => {
    setActionButtonShow(null);
  };

  // navigate to Edit page
  const rollEditHandler = (tableId) => {
    navigate(`/Administration/editRole/${tableId}`);
  };

  const RoledeleteHandler = (role) => {
    setActionButtonShow(false);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(roleDeleteAction(role))    console.log(117,data);
;
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };

  const handleOpen = (id) => {
    if (component === "employee") {
      navigate(`${showUrl}/${id}`);
    } else {
      let arrData;
      if (roleData?.some((obj) => obj?.id === id)) {
        arrData = roleData?.find((obj) => obj?.id === id);
      }

      setPopupData(arrData);
      setOpen(true);
    }
  };

  const CustomSortIcon = ({ direction }) => {
    return direction === "asc" ? (
      <img
        src="/menuIcons/tableUpSort.png"
        className="incentiveCustomIcon"
        alt="gsl"
        style={{ padding: "15px" }}
      />
    ) : (
      <BiSortAlt2 className="incentiveCustomIcon" />
    );
  };

  // sorting table
  const [sortBy, setSortBy] = useState(""); // Current sort column
  const [sortOrder, setSortOrder] = useState("asc"); // Current sort order

  const requestSort = (column) => {
    let newSortOrder = "asc";

    if (column === sortBy && sortOrder === "asc") {
      newSortOrder = "desc";
    }

    setSortBy(column);
    setSortOrder(newSortOrder);
  };

  let sortedData = useMemo(() => {
    if (sortBy && data) {
      const sortedItems = [...data].sort((a, b) => {
        if (sortOrder === "asc") {
          return a[sortBy] < b[sortBy] ? -1 : 1;
        } else {
          return a[sortBy] < b[sortBy] ? 1 : -1;
        }
      });

      return sortedItems;
    }

    return data;
  }, [data, sortBy, sortOrder]);

  const partnerCommissionEdit = (dataId) => {
    try {
      setEditOpen(!editOpen)
      data.map((value) => {
        if(value.id === dataId) {
          setRoleName(value.column1)
          setCommissionPercentage(value.column2)
        }

        dispatch(partnerCommissionCategoryEdit(tableId))
      })
    } catch(error) {
      console.error(error);
    }
  }

  const partnerCommissionhandleClick = (e) => {
    e.preventDefault()
    try {
      dispatch(partnerCommissionCategoryEdit(tableId, roleName, commissionPercentage))
      Swal.fire(
        "Updated!",
        "Data is updated successfully.",
        "success"
      );
    } catch(error) {
      console.error(error);
    }
  }

  const handleClose = () => {
    setEditOpen(false)
  }

  // check handler

  // Create a function to handle selecting individual rows:
  const handleSelectRow = (rowId) => {
    let updatedSelectedRows;
    if (selectedRows.includes(rowId)) {
      updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      updatedSelectedRows = [...selectedRows, rowId];
      setSelectedRows(updatedSelectedRows);
    }
    // setIdsFunction(updatedSelectedRows);
  };

  // Create a function to handle selecting all rows:

  return (
    <>
      {sortedData.length > 0 ? (
        <Table className="incentiveTable">
          <TableHead>
            <TableRow className="incentiveTableCell">
              <TableCell>
                <Checkbox
                  // checked={selectedRows.length === sortedData.length}
                  // onChange={handleSelectAllRows}
                  style={{ color: "#f81b82" }}
                />
              </TableCell>
              {columns?.map((column) => {
                if (column.hidden) {
                  return null;
                }
                return (
                  <TableCell key={column.field} className="incentiveTableCell">
                    <TableSortLabel
                      className="incentiveHeaderText"
                      active={column === sortBy}
                      direction={sortOrder}
                      onClick={() => requestSort(column)}
                      IconComponent={
                        column.field !== "action" && CustomSortIcon
                      }
                    >
                      {column.title}
                    </TableSortLabel>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((item, indx) => (
              <TableRow className="incentiveTable" key={indx}>
                <TableCell>
                  <Checkbox
                    checked={selectedRows.includes(item.id)}
                    onChange={() => handleSelectRow(item.id)}
                    style={{ color: "#f81b82" }}
                  />
                </TableCell>
                <TableCell>{item.sl}</TableCell>
                {item.column1 && <TableCell>{item.column1}</TableCell>}

                {item.column2 && <TableCell>{`${item.column2}%`}</TableCell>}

                {item.column3 && <TableCell>{item.column3}</TableCell>}

                {item.column4 && <TableCell>{item.column4}</TableCell>}
                <TableCell>
                  <SlOptionsVertical
                    id="demo-positioned-button"
                    aria-controls={
                      openActionButton ? "demo-positioned-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={openActionButton ? "true" : undefined}
                    onClick={(e) => {
                      handleClickAction(e, item.id);
                    }}
                    variant="outlined"
                    style={{ marginLeft: "10px", color: "#F80B7A" }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter />
        </Table>
      ) : (
        <TableNoItemComponent />
      )}
      {/* TABLE ACTION MENU START*/}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={actionButtonShow}
        open={openActionButton}
        onClose={handleCloseAction}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          borderColor: "black",
          borderRadius: "24px",
          mt: 1.5,
          width: "auto",
          height: "auto",
        }}
      >
        <Box style={{ display: "flex", justifyContent: "flex-end" }}>
          {/* <MenuItem>
            <AiOutlineEye
              onClick={() => handleOpen(tableId)}
              className="icons"
              style={{
                fontSize: "lg",
                width: "20px",
                height: "19px",
              }}
            />
          </MenuItem> */}

          <MenuItem>
            <RiDeleteBin6Line
              onClick={() => {
                if (isDeletePrevilage(subMenu)) {
                  setActionButtonShow(false);
                  Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      dispatch(partnerCommissionDeleteAction(tableId));
                      Swal.fire(
                        "Deleted!",
                        "Your file has been deleted.",
                        "success"
                      );
                    }
                  });
                } else {
                  setOpenAlert(true);
                }
              }}
              style={{
                fontSize: "lg",
                width: "20px",
                height: "19px",
              }}
              className="icons"
            />

          </MenuItem>
          <MenuItem>

            <TbEdit
              style={{
                fontSize: "lg",
                width: "20px",
                height: "19px",
              }}
            onClick={() => {
              if (isEditPrevilage(subMenu)) {
                partnerCommissionEdit(tableId)
                setActionButtonShow(false);  
              } else {
                setOpenAlert(true);
              }
            }}
            />
          </MenuItem>

        </Box>
      </Menu>

      {/* Edit dialogue box */}

      <Dialog
        open={editOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            bottom: "33vh",
            width: "850px",
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <TypographyText title={"Edit Partner Commission"} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box mt={1.5}>
              <InputField
                label="Category Name"
                handleChange={(e) => setRoleName(e.target.value)}
                widthSize="100%"
                value={roleName}
                required
                InputType="text"
              />

              <InputField
                label="Commission Percentage"
                handleChange={(e) => setCommissionPercentage(e.target.value)}
                widthSize="100%"
                value={commissionPercentage}
                required
                InputType="number"
              />
              {/* {error && (
                <Typography
                  sx={{ color: "red", fontSize: "12px", mt: "-15px" }}
                >
                  Please enter a value less than 100
                </Typography>
              )} */}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SubmitButton
            title="Update"
            submit="click"
            widthSize="90px"
            heightSize="40px"
            type="click"
            handleSubmit={partnerCommissionhandleClick}
          />
        </DialogActions>
      </Dialog>

      {/* Edit dialogue box end */}


      {/* {/*TABLE ACTION MENU END */}
      {openAlert && (
        <PremissionDialog
          openAlert={openAlert}
          handleClose={handleCloseDialog}
        />
      )}
    </>
  );
};
